// Палитра как до 23.10.2026 (вернули по просьбе менторов: «Слива» утомляла глаза).
// Все цвета кабинета - только отсюда; новый цвет = новый токен здесь, не hex в странице.
export const ui = {
    page: '#FFFFFF',
    card: '#FFFFFF',
    border: '#F0E8EE',
    ink: '#17141A',
    sub: '#6E6875',
    muted: '#9A929F',
    pink: '#C2338D',
    pinkSoft: '#FBE9F4',
    track: '#F3EBF1',
    green: '#2FA36B',
    surface: '#FCFAFC',
    pinkDark: '#A02673',
    radius: '12px',
}

export const tone = {
    ok: { text: '#1F9D57', bg: '#E8F6EE', border: '#B9E6C9' },
    warn: { text: '#B26B00', bg: '#FDF3E4', border: '#F3E0A0' },
    yellow: { text: '#A87D00', bg: '#FFF6D6', border: '#F3E0A0' },
    bad: { text: '#D63A3A', bg: '#FDE8E8', border: '#F5C2C2' },
    info: { text: '#4F72EA', bg: '#EAF0FD', border: '#C1DEFF' },
    neutral: { text: '#6E6875', bg: '#F5F3F6', border: '#F0E8EE' },
}

export type Tone = keyof typeof tone

export const tableStyles = {
    container: {
        border: `1px solid ${ui.border}`,
        borderRadius: '16px',
        overflow: 'hidden',
    },
    head: {
        '& .MuiTableCell-root': {
            backgroundColor: ui.surface,
            borderBottom: `1px solid ${ui.border}`,
            color: ui.sub,
            fontSize: '13px',
            fontWeight: 600,
            letterSpacing: '0.02em',
            textTransform: 'uppercase',
        },
    },
    row: {
        '& .MuiTableCell-root': {
            borderBottom: `1px solid ${ui.border}`,
            color: ui.ink,
            fontSize: '14px',
        },
        '&:hover': {
            backgroundColor: ui.surface,
        },
    },
}
